const SCREEN = {
  LOGIN: 'Login',
  FORGOT_LOGIN_DETAILS: 'Login (Forgot Login Details)',
  FORGOT_EMAIL_ADDRESS: 'Login (Forgot Email Address)',
  EMAIL_REMINDER_SUCCESS: 'Email Reminder - Success Message',
  FORGOT_EMAIL_MULTIPLE_ATTEMPTS_ERROR:
    'Forgot Email Address - Multiple Attempts Error ',
  FORGOT_EMAIL_TIMEOUT_ERROR: 'Forgot Email Address - Timeout Error',
  FORGOT_EMAIL_INVALID_OTP_ERROR: 'Forgot Email Address - Invalid OTP',
  LOGOUT: 'Logout',
  PAIDYPLUSTOP: 'Paidy+ Top',
};

const ITEM = {
  EMAIL: 'Email',
  PHONE: 'Phone',
  PIN: 'Pin Code',
  SUBMIT: 'Submit', // Means the submit button in forms
  CHANGE_PHONE: 'Change Phone',
  FORGOT_EMAIL_ADDRESS: 'Change Phone Number',
  CHANGE_PHONE_OR_REMIND_EMAIL: 'Change Phone or Remind Email Address',
  ENTER_PHONE_NUMBER: 'Enter Phone Number',
  YES: 'Yes',
  NO: 'No',
  CLOSE_DIALOG: 'Close (Dialog)',
};

const ACTION = {
  PAGE_VIEW: 'Page View',
  CLICK: 'Click',
  FIELD_EDIT: 'Field Edit',
  ERROR: 'Error',
};

const FAIL = {
  RECAPTCHA: 'Init ReCaptcha fails',
  AUTHENTICATION: 'Authentication Failure',
};

const SUCCESS = {
  AUTHENTICATION: 'Authentication Success',
};

const EVENT_TYPE = {
  SMS: 'SMS',
};

export { ACTION, EVENT_TYPE, FAIL, ITEM, SCREEN, SUCCESS };
